import { useState } from "react";
import { Link } from "wouter";
import { useAuth } from "../context/AuthContext.jsx";
import { IllustrationCompass } from "../components/illustrations.jsx";

export default function Login() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    await login(email, password);
    setSubmitting(false);
  }

  return (
    <div className="page" style={{ maxWidth: 400, paddingTop: "18vh" }}>
      <div className="kicker" style={{ marginBottom: 28 }}>
        <span className="the-line" />
        CONQUEST
      </div>
      <div className="illustration-hero-wrap">
        <IllustrationCompass className="illustration-hero" />
      </div>

      <h1 style={{ marginBottom: 32 }}>Sign in</h1>
      <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        {error && <div style={{ color: "var(--error)", fontSize: 13.5 }}>{error}</div>}
        <div style={{ fontSize: 13.5 }}>
          <Link href="/forgot-password">Forgot password?</Link>
        </div>
        <button className="btn-primary" type="submit" disabled={submitting} style={{ marginTop: 8 }}>
          {submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <div style={{ marginTop: 20, fontSize: 13.5, color: "var(--muted)" }}>
        Conquest is joined by invitation.
      </div>
      <div style={{ marginTop: 8, fontSize: 13.5 }}>
        Not invited yet? <Link href="/take-the-diagnostic">Take the Standing Check</Link>
      </div>
    </div>
  );
}
